import { Injector, Type } from '@angular/core';

// @dynamic
export class DependencyInjector {

    /**
     * The injector instance.
     */
    static injector: Injector;

    /**
     * Set the Angular injector instance.
     *
     * @param {Injector} instance
     */
    public static setInstance(instance: Injector): void {
        this.injector = instance;
    }

    /**
     * Get the Angular injector instance.
     *
     * @returns {Injector}
     */
    public static getInstance(): Injector {
        const injector = this.injector;

        if (!injector) {
            throw Error('Instance of the Angular Injector could not be found, maybe it was not ' +
                'set yet? The instance has to be set before the first module that uses the app ' +
                'function.');
        }

        return injector;
    }

    /**
     * Get the service instance with the given token.
     *
     * @param {Type<T>} token
     * @returns {T}
     */
    public static get<T>(token: Type<T>): T {
        const injector = this.getInstance();
        const instance = injector.get(token);

        if (!instance) {
            throw Error('Instance of ' + token + ' could not be found by the injector, maybe it ' +
                'is not registered yet? The service should be declared in the providers of the ' +
                'module.');
        }

        return instance;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/injector.ts